import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import classNames from 'classnames';

// Components
import { PrimaryButton, DeemphasizedButton } from 'components/widgets/buttons';
import { FixedTable } from 'components/content-containers/tables';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';


export default function LineItemsTable({ enterReceipt, purchaseOrder, enteringReceipt }) {
  const { unbilledLineItems, automated, quantity, unbilledQuantity, status, approvedBy } = purchaseOrder;

  return (
    <FixedTable
      invisibleHeaders={[
        'col-expense-button',
        'col-duration',
        'col-money',
        'col-money',
        ''
      ]}
      headerRow={
        <tr>
          <th colSpan="4">Items Not Yet Charged</th>
          <th className="right-align">
            {`${quantity - unbilledQuantity}/${quantity} Charged`}
          </th>
        </tr>
      }
    >
      <tbody>
        {_.map(unbilledLineItems, (lineItem, index) =>
          <tr className="line-item-row" key={lineItem.id}>
            { index === 0 &&
              <td rowSpan={unbilledLineItems.length}>
                { automated && !enteringReceipt &&
                  <Tooltip title={getTooltip(purchaseOrder)} className={classNames({ danger: status !== 'Archived' })}>
                    <DeemphasizedButton
                      className="add-charge automated-purchase-order"
                      onClick={enterReceipt}
                      disabled={status === 'Archived' || !approvedBy}
                    >
                      <SVG src="svg/automatic.svg" />
                      <span>Add Charge</span>
                    </DeemphasizedButton>
                  </Tooltip>
                }
                { !automated && !enteringReceipt &&
                  <Tooltip title={getTooltip(purchaseOrder)}>
                    <PrimaryButton onClick={enterReceipt} disabled={status === 'Archived'}>
                      <SVG src="svg/add.svg" />
                      <span>Add Charge</span>
                    </PrimaryButton>
                  </Tooltip>
                }
              </td>
            }
            <td className="right-align deemphasize">
              {lineItem.unbilledQuantity}
            </td>
            <td className="right-align deemphasize">
              {numeral(lineItem.unitCost).format('$0,0.00')}
            </td>
            <td className="right-align">
              {numeral(lineItem.unbilledQuantity * lineItem.unitCost).format('$0,0.00')}
            </td>
            <td>
              {lineItem.description}
            </td>
          </tr>
        )}
      </tbody>
    </FixedTable>
  );
}

LineItemsTable.propTypes = {
  enterReceipt: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.object.isRequired,
  enteringReceipt: PropTypes.bool
};


// Internal function
function getTooltip(purchaseOrder) {
  if (purchaseOrder.status === 'Archived') return 'This purchase order has been deleted';
  if (!purchaseOrder.approvedBy) return 'You need to enter a client approver before adding a charge';
  if (purchaseOrder.automated) return 'Be careful! This purchase order was automatically generated. You shouldn\'t need to enter a charge.';
}



// WEBPACK FOOTER //
// ./app/components/models/purchases/purchase-line-items-table.js